import Vue from 'vue'
import url from '@/services/ApiServices/apiUrls'
import { store } from '../../store/store'

export const unomiApis = new Vue({
	methods: {
		async postEvents (postEventData) {
			if (!this.$cookies.get('unomi-session-id')) {
				this.$cookies.set('unomi-session-id', Math.random().toString(36).slice(2), 60 * 60 * 24)
				Vue.http.headers.common['Unomi-Session'] = Vue.cookies.get('unomi-session-id')
			}
			try {
				return await this.$http.post(url.eventServeUrl, {
					sessionId: this.$cookies.get('unomi-session-id'),
					events: [
						{
							eventType: postEventData.target.itemId,
							scope: postEventData.scope,
							source: {
								itemType: 'site',
								scope: postEventData.scope,
								itemId: 'msbsite'
							},
							target: {
								itemType: postEventData.eventType,
								scope: postEventData.scope,
								itemId: postEventData.target.itemId,
								properties: {
									pageInfo: {
										referringURL: postEventData.target.reffedUrl
									}
								}
							}
						}
					]
				})
			} catch (err) {
				throw err
			}
		},
		async getSegments () {
			try {
				const getUrl = url.getSegmentsUrl + this.$cookies.get('unomi-session-id')
				const segmentsData = await this.$http.get(getUrl)
				store.dispatch('analytics/setSegmentsData', segmentsData.data)
				return segmentsData
			} catch (e) {

			}
		}
	}
})
